


























































































































































































































import { Component, Vue } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
import CustomForm from '@/components/custom-form/index.vue'
import Api from '@/api/marketing/live/index'
import GoodsApi from '@/api/goods/list'

@Component({
  components: {
    CustomForm,
  },
})
export default class CommissionList extends AbpBase {
  modal2: boolean = false
  modal3: boolean = false
  priceType: string = '一口价'
  onePrice: any = ''
  oldPrice: any = ''
  tabLoading: boolean = false
  newPrice: any = ''
  goodsName: string = ''
  selectGoodsObj: any = {}
  isCheckAll: boolean = false
  stepModal: boolean = false
  currentSteps: number = 0
  stepDatas: any[] = []
  filters = [
    {
      label: '添加时间',
      type: 'date',
      props: {
        placeholder: '请选择添加日期',
      },
      key: 'startTime',
    },
    {
      label: '商品状态',
      type: 'select',
      props: {
        placeholder: '请选择状态',
      },
      key: 'status',
      options: [
        {
          value: 0,
          text: '未开始',
        },
        {
          value: 1,
          text: '进行中',
        },
        {
          value: 2,
          text: '已结束',
        },
      ],
    },
  ]
  filtersModal = [
    {
      label: '关键字搜索：',
      type: 'input',
      props: {
        placeholder: '',
      },
      key: 'keyWord',
    },
  ]
  columns = [
    {
      type: 'selection',
      width: 60,
      align: 'center',
    },
    {
      title: '图片',
      slot: 'coverImgUrl',
      align: 'center',
      // width: 100,
    },
    {
      title: '商品编号',
      key: 'code',
      align: 'center',
      //  width: 100,
    },
    {
      title: '商品名称',
      key: 'name',
      align: 'center',
      //  width: 100,
    },
    {
      title: '商品ID',
      key: 'goodsId',
      align: 'center',
      // width: 200
    },
    {
      title: '定价类型',
      slot: 'priceType',
      align: 'center',
      // width: 100,
    },
    {
      title: '价格1',
      key: 'price',
      align: 'center',
      // width: 200
    },
    {
      title: '价格2',
      key: 'price2',
      align: 'center',
      // width: 200
    },
    // {
    //   title: '商品小程序路径',
    //   key: 'url',
    //   align: 'center',
    //   // width: 200
    // },
    // {
    //   title: '添加时间',
    //   slot: 'startTime',
    //   align: 'center',
    //   // width: 140,
    // },
    {
      title: '商品状态',
      slot: 'aditSatus',
      align: 'center',
      // width: 200
    },
    {
      title: '操作',
      slot: 'action',
      width: 350,
      align: 'center',
    },
  ]
  columnsShops: any[] = [
    {
      type: 'selection',
      width: 60,
      align: 'center',
    },

    {
      title: '商品图片',
      slot: 'pictureUrl',
      align: 'center',
    },
    {
      title: '商品编码',
      key: 'code',
      align: 'center',
    },
    {
      title: '商品名称',
      key: 'name',
      align: 'center',
    },
    {
      title: '价格',
      key: 'price',
      align: 'center',
    },
    {
      title: '操作',
      slot: 'action',
      align: 'center',
    },
  ]
  selectionRow: any[] = []
  exporting: boolean = false
  copyData = []
  goodsData: any[] = []
  pager = {
    pageIndex: 1,
    pageSize: 10,
    total: 0,
  }
  pageShops = {
    totalCount: 0,
    currentPage: 1,
    maxResultCount: 10,
  }
  mounted() {
    this.loadData()
  }
  submitChange(form, valid) {
    if (valid) {
      console.log(form)
      this.loadData(form)
    }
  }
  submitModalChange(form, valid) {
    if (valid) {
      console.log(form)
      // this.loadData(form)
      this.getOwnerGoodsList(form)
    }
  }
  loadData(form = {}) {
    // let startTime = form['startTime'] ? this.dateString(form['startTime']) : null
    // let endTime = form['endTime'] ? this.dateString(form['endTime']) : null
    this.tabLoading = true
    Api.getLiveRoomCommodityList(this.pager.pageSize, this.pager.pageIndex).then((res) => {
      this.tabLoading = false
      this.pager.total = res.data.totalCount
      this.copyData = res.data.items
    })
  }
  onPageChange(pageIndex) {
    this.pager.pageIndex = pageIndex
    // this.loadData((this.$refs.lineForm as any).form)
    this.loadData()
  }
  submitFn() {
    let form: any = this.$refs.lineForm
    form.submit()
  }
  addLiveShops() {
    this.getOwnerGoodsList()
    this.modal2 = true
  }
  getOwnerGoodsList(form = {}) {
    let keyWord = form['keyWord']
    let { maxResultCount, currentPage } = this.pageShops
    GoodsApi.getList(maxResultCount, currentPage, keyWord)
      .then((res) => {
        let { totalCount, items } = res.data
        this.pageShops.totalCount = totalCount
        this.goodsData = items
      })
      .catch(() => {
        this.pageShops.totalCount = 0
        this.goodsData = []
      })
  }
  changePrice(row: any) {
    console.log(row)
    this.modal3 = true
    this.selectGoodsObj = row
    this.goodsName = row.name
  }
  // 修改商品
  handleChangeGoods(row: any) {
    console.log(row)
    if (!row.couponId) {
      this.$router.push({
        name: 'updateGoodsInfo',
        query: {
          id: row.id,
        },
      })
    } else {
      this.$router.push({
        name: 'addLiveCoupon',
        query: {
          id: row.id,
        },
      })
    }
  }
  submitReview(row: any) {
    console.log(row)
    if (row.coverImgUrl == null || row.coverImgUrl == '') {
      this.$Notice.error({ desc: '商品没有图片,不能提交' })
      return
    }
    this.tabLoading = true

    Api.pushWechatById(row.id)
      .then((res) => {
        this.$Notice.success({ desc: '提交成功' })
        this.tabLoading = false
        this.loadData()
      })
      .catch((r) => {
        this.tabLoading = false
      })
  }

  // 撤回审核
  callReview(row: any) {
    console.log(row)
    Api.reCallWechatById(row.id).then((res) => {
      this.$Notice.success({ desc: '撤回成功' })
      this.loadData()
    })
  }
  // 重新提交
  repushReview(row: any) {
    console.log(row)
    Api.rePushWechatById(row.id).then((res) => {
      this.$Notice.success({ desc: '提交成功' })
      this.loadData()
    })
  }
  // 更新商品信息
  updateData(row: any) {
    console.log(row)
    Api.reUpdateWechatById(row.id).then((res) => {
      this.$Notice.success({ desc: '更新成功' })
      this.loadData()
    })
  }
  deleteRow(row: any) {
    this.$Modal.confirm({
      title: '提示',
      content: `删除无法恢复, 是否继续?`,
      onOk: () => {
        Api.deleteGoodsById(row.id).then((res) => {
          this.$Notice.success({ desc: '删除成功' })
          this.loadData()
        })
      },
    })
  }
  handleTableAllCancel() {
    this.isCheckAll = false
  }

  handleTableAll() {
    this.isCheckAll = true
  }

  handleSelectChange(selection) {
    this.isCheckAll = selection.length === this.copyData.length
  }
  handleSelectAll() {
    if (!this.copyData.length) return // ;(this.$refs.selectiontab as any).selectAll(!this.isCheckAll)
    ;(this.$refs.selectiontab as any).data
      .filter((item) => item.aditSatus == -1)
      .forEach((item1) => {
        this.$set(item1, '_checked', !this.isCheckAll)
      })
    this.isCheckAll = !this.isCheckAll
  }
  /**
   * 批量提交审核
   */
  submitReviewList() {
    let selection = (this.$refs.selectiontab as any).getSelection()
    console.log(selection)
    if (!selection.length) {
      this.$Notice.warning({
        desc: '请先选择商品',
      })
      return
    }
    var nostatus = selection.find((x) => x.aditSatus != -1)
    console.log(nostatus)
    if (nostatus != undefined && JSON.stringify(nostatus) != '{}') {
      this.$Notice.error({ desc: nostatus.name + '不是未提交状态' })
      return
    }

    var noimg = selection.find((x) => x.coverImgUrl == null || x.coverImgUrl == '')
    console.log(noimg)
    if (noimg != undefined && JSON.stringify(noimg) != '{}') {
      this.$Notice.error({ desc: noimg.name + '没有图片不能提交' })
      return
    }
    this.stepModal = true

    this.selectionRow = selection
    selection.forEach((item) => {
      Api.pushWechatById(item.id)
        .then((res) => {
          //  this.stepDatas = [];
          // this.$Notice.success({ desc: "提交成功" });
          this.stepDatas.push(item)
        })
        .catch((r) => {
          this.tabLoading = false
        })
    })
  }
  /**
   * 添加直播优惠券
   */
  addLiveCoupon() {
    this.$router.push({
      name: 'addLiveCoupon',
    })
  }
  ok() {
    this.stepModal = false
    this.loadData()
  }
  cancel() {
    this.modal2 = false
    this.modal3 = false
  }
  handleChangePrice() {
    let data = {
      name: this.selectGoodsObj.name,
      priceType: this.priceType == '一口价' ? 1 : 3,
      coverImgUrl: this.selectGoodsObj.coverImgUrl,
      price: 0,
      price2: 0,
      aditSatus: -1,
    }
    if (this.priceType == '一口价') {
      if (this.onePrice.trim().length <= 0) {
        this.$Message.warning('请输入一口价')
        return false
      } else {
        data.price = this.onePrice
      }
    } else if (this.priceType == '折扣价') {
      if (this.oldPrice.trim().length <= 0) {
        this.$Message.warning('请输入原价')
        return false
      } else if (this.newPrice.trim().length <= 0) {
        this.$Message.warning('请输入现价')
        return false
      } else {
        data.price = this.oldPrice
        data.price2 = this.newPrice
      }
    }

    Api.updatedGoodsInfoById(this.selectGoodsObj.id, data).then((res) => {
      this.$Notice.success({ desc: '修改成功' })
      this.modal3 = false
      this.loadData()
    })
  }
  selectGoods(row: any) {
    console.log(row)
    let data = {
      name: row.name,
      priceType: 1,
      code: row.code,
      coverImgUrl: row.pictureUrl,
      price: row.price,
      productId: row.id,
      aditSatus: -1,
    }
    var arr = []
    arr.push(data)
    Api.selectGoodsByMyGoodsList(arr).then((res) => {
      console.log('选择本地商品', res)
      this.$Notice.success({ desc: '添加成功' })
      this.modal2 = false
      this.loadData()
    })
  }
  selectGoodList() {
    let selection = (this.$refs.selection as any).getSelection()
    console.log(selection)
    if (selection.length == 0) {
      this.$Notice.error({ desc: '请选择商品' })
      return
    }
    var arr = []
    for (var i = 0; i < selection.length; i++) {
      var row = selection[i]
      let data = {
        name: row.name,
        priceType: 1,
        code: row.code,
        coverImgUrl: row.pictureUrl,
        price: row.price,
        productId: row.id,
        aditSatus: -1,
      }
      arr.push(data)
    }
    Api.selectGoodsByMyGoodsList(arr).then((res) => {
      console.log('选择本地商品', res)
      this.$Notice.success({ desc: '添加成功' })
      this.modal2 = false
      this.loadData()
    })
  }
  onPageShopsChange(pageIndex) {
    this.pageShops.currentPage = pageIndex
    console.log(this.$refs['lineModalForm'])
    this.getOwnerGoodsList(this.$refs['lineModalForm'])
  }
  /**
   * 导出excel表格
   */
  // exportExcel() {
  //   this.exporting = true
  //   let refForm: any = this.$refs.lineForm
  //   const form = refForm.getForm()
  //   console.log(form)
  //   let startTime = form['startTime']
  //   let endTime = form['endTime']
  //   Api.exportWidthdrawReportFile(this.pager.pageSize, this.pager.pageIndex, startTime, endTime)
  //     .then((res) => {
  //       console.log(res)
  //       this.exporting = false
  //       this.download(res.data)
  //     })
  //     .catch((err) => {
  //       this.exporting = false
  //     })
  // }
  // download(data) {
  //   if (!data) {
  //     return
  //   }
  //   let url = window.URL.createObjectURL(new Blob([data]))
  //   let link = document.createElement('a')
  //   link.style.display = 'none'
  //   link.href = url
  //   link.setAttribute('download', '提佣统计表.xlsx')

  //   document.body.appendChild(link)
  //   link.click()
  // }
}
